import { required } from '@unitedtraders/validators';
import { useBalance } from '../../hooks/useBalance';
import { inBalance } from '../../utils/validators';

export const useAmountValidators = (currency: string) => {
  const { balance } = useBalance(currency);

  return [required(), ...(balance ? [inBalance(balance)] : [])];
};
